import {
    simOnlyOldDataAllowance,
    simOnlyOldMonthlyCost,
    SimOnlyPlan,
    simOnlyPlanDataLimit, simOnlyPlanDataRoaming, simOnlyPlanMonthlyCost
} from "../../../Model/Sales/SimOnlyPlan";
import {CmsContent} from "../../../Model/CmsContent/CmsContent";
import {optHtmlContent, renderDynamicContent} from "../../../Utilities/CmsUtilities";
import {KeyValue} from "../../../Types/KeyValue";
import * as React from "react";
import {addActivationCodeQueryParam, addPromoQueryParam, SALES_PORTAL_ROUTES} from "../../../Routes/SalesPortalRoutes";
import {useNavigate} from "react-router-dom";
import {ApplicationContext} from "../../../ApplicationContext";

interface SimCardInfoProps {
    readonly cmsContent: CmsContent[];
    readonly selected: boolean;
    readonly simOnlyPlan: SimOnlyPlan;
    readonly activationCode: string | null;
    readonly expanded: boolean;
    readonly planHexColor: string;
    readonly index: number;
    onCardClick: () => void;
    onButtonClick: (packageCode: string | null) => void;
    setSelectedPlan: (simOnlyPlan: SimOnlyPlan) => void;
    setPromoCode: (promo: string | null) => void,
    setSelectedPlanIndex: (index: number) => void;
}

const SimCardInfo = (props: SimCardInfoProps): JSX.Element | null => {
    const toggleRef = React.useRef<HTMLButtonElement>(null);

    const plan = props.simOnlyPlan
    const navigate = useNavigate()

    const applicationContext = React.useContext(ApplicationContext)
    const optOtherPlanCard = optHtmlContent(props.cmsContent, "sp-card-sim-only-plan-other")
    const optSelectedOtherPlanCard = optHtmlContent(props.cmsContent, "sp-card-sim-only-plan-other-selected")

    // Plan with all you need label
    const packageCodeWithAllYouNeedLabel = "SD_Unlimited"
    const optOtherPlanCardAllYouNeed = optHtmlContent(props.cmsContent, "sp-card-sim-only-plan-other-all-you-need")
    const optSelectedOtherPlanCardAllYouNeed = optHtmlContent(props.cmsContent, "sp-card-sim-only-plan-other-selected-all-you-need")
    const optSelectedSimCardInfoList = optHtmlContent(props.cmsContent, "sim-card-info-list")

    if (optOtherPlanCard && optSelectedOtherPlanCard && optSelectedSimCardInfoList &&
        optOtherPlanCardAllYouNeed && optSelectedOtherPlanCardAllYouNeed) {

        const dataAllowanceElement = plan.promoAddonLimit != null ? (
            <div>
                <s>{simOnlyOldDataAllowance(plan)}</s> <span>{simOnlyPlanDataLimit(plan)}</span>
            </div>
        ) : (
            <span>{simOnlyPlanDataLimit(plan)}</span>
        );
        const planPriceElement = plan.promoDiscount ? (
            <div>
                <s>£{simOnlyOldMonthlyCost(plan)}</s> <span>£{simOnlyPlanMonthlyCost(plan)}</span>
            </div>
        ) : (
            <span>£{simOnlyPlanMonthlyCost(plan)}</span>
        );

        const templateTags: KeyValue<string | React.ReactNode | React.ReactNode[]>[] = [
            {key: "DATA_ALLOWANCE", value: dataAllowanceElement},
            {key: "PLAN_DESCRIPTION", value: plan.description},
            {key: "PLAN_PRICE", value: planPriceElement},
            {key: "PLAN_COLOUR", value: props.planHexColor.substring(1)}
        ]

        const isAllYouNeedLabel = plan.packageCode === packageCodeWithAllYouNeedLabel;

        let template;
        if (props.selected) {
            template = isAllYouNeedLabel ? optSelectedOtherPlanCardAllYouNeed : optSelectedOtherPlanCard;
        } else {
            template = isAllYouNeedLabel ? optOtherPlanCardAllYouNeed : optOtherPlanCard;
        }


        const simInfoContent = renderDynamicContent(template, templateTags);

        return (
            <>
                <style>
                    {`
                    .sim-info-toggle-btn {
                        width: 100%;
                        border: none;
                        background: transparent;
                        cursor: pointer;
                        text-align: center;
                        font-weight: 600;
                        margin-top: -12px;
                        position: relative;
                        z-index: 2;
                    }
                    
                    .sim-info-rounded-${props.planHexColor.substring(1)} {
                        margin-bottom: 10px;
                        border-top-left-radius: 15px;
                        border-top-right-radius: 15px;
                        border-bottom-right-radius: 15px;
                        border-bottom-left-radius: 15px;
                        padding-bottom: 0rem !important;
                        background: ${props.planHexColor};
                    }
                    
                    .sim-info-container-${props.planHexColor.substring(1)} {
                        margin-bottom: 10px;
                        border-top-left-radius: 15px;
                        border-top-right-radius: 15px;
                        border-bottom-right-radius: 0px;
                        border-bottom-left-radius: 0px;
                        padding-bottom: 0.5rem !important;
                        border-color: ${props.planHexColor};
                    }
                    
                    .sim-info-splitter {
                        width: 95%;
                        background-image: initial;
                        background-position-x: initial;
                        background-position-y: initial;
                        background-size: initial;
                        background-repeat: initial;
                        background-attachment: initial;
                        background-origin: initial;
                        background-clip: initial;
                        background-color: rgb(255, 255, 255);
                        margin-right: auto;
                        margin-bottom: 0.5rem;
                        margin-left: auto;
                        margin-top: -15px;
                    }
                    
                    .sp-card-dot-selected-${props.planHexColor.substring(1)} {
                        background-color: ${props.planHexColor};
                    }
                    
                    .sp-card-dot-${props.planHexColor.substring(1)} {
                         border-color: ${props.planHexColor};
                    }
                `}
                </style>
                <div
                    onClick={(e: React.MouseEvent<HTMLDivElement>) => {
                        props.setSelectedPlan(props.simOnlyPlan)
                        props.setSelectedPlanIndex(props.index)
                        props.setPromoCode(props.simOnlyPlan.promoCode)
                        navigate(
                            addActivationCodeQueryParam(
                                addPromoQueryParam(
                                    SALES_PORTAL_ROUTES.SimOnly.PurchaseSignUp(
                                        applicationContext.urlContext,
                                        plan.packageCode
                                    ),
                                    plan.promoCode
                                ),
                                props.activationCode
                            )
                        );

                        if (toggleRef.current?.contains(e.target as Node)) {
                            return;
                        }

                        props.onCardClick();
                    }}
                    style={{cursor: "pointer"}}
                    className={`d-flex flex-column sim-info-rounded-${props.planHexColor.substring(1)}`}
                >
                    {simInfoContent}
                    {!props.expanded  && <button
                        ref={toggleRef}
                        type="button"
                        className="sim-info-toggle-btn"
                        onClick={() => props.onButtonClick(props.simOnlyPlan.packageCode)}
                    >
                        View details ▼
                    </button>}
                    {props.expanded && (
                        <>
                            <hr className="sim-info-splitter" />

                            {props.selected && renderDynamicContent(optSelectedSimCardInfoList, [{ key: "MONTHLY_PRICE", value: `${simOnlyPlanMonthlyCost(plan)}` },
                                { key: "ROAMING_DATA", value: simOnlyPlanDataRoaming(plan)}])}

                            <button
                                type="button"
                                ref={toggleRef}
                                className="sim-info-toggle-btn"
                                onClick={() => props.onButtonClick(null)}
                            >
                                Hide details ▲
                            </button>
                        </>
                    )}

                </div>
            </>
        )
    } else {
        return null
    }
}

export default SimCardInfo